import { AuthService } from '../authorization/services';


export const run = ['Restangular', 'NotifyService', '$state', 'DTDefaultOptions', 'gettextCatalog', '$window', 'PermPermissionStore', 'PermRoleStore', 'deviceDetector', (
    Restangular: Restangular.IService,
    notifyService: aboTheme.INotifyService,
    $state: ng.ui.IStateService,
    DTDefaultOptions: any,
    gettextCatalog: ng.gettext.gettextCatalog,
    $window: ng.IWindowService,
    PermPermissionStore: angular.permission.PermissionStore,
    PermRoleStore: angular.permission.RoleStore,
    deviceDetector: any,
) => {
     //SET LANGUAGE
    var lang = $window.navigator.language;
    var lf = '';
    switch(lang) {
        case 'nl':
        case 'nl-NL':
            lf = 'nl_NL';
        break;
        default: lf = 'en_US';
    }

    gettextCatalog.setCurrentLanguage(lf);
    gettextCatalog.debug = false;

    //CHECK IF IE
    var browser = deviceDetector.browser;
    if(deviceDetector.browser == "ie") {
        $state.go('browser');
    }

    Restangular.setErrorInterceptor((response, deferred, responseHandler) => {
        switch (response.status) {
            case 401:
                notifyService.error(response.status.toString(), 'Unauthorized');
                $state.go('login');
                break;
            case 403:
                $state.go('login');
                break;
            default:
                notifyService.error(response.status.toString());
                break;
        }
    });
    Restangular.addResponseInterceptor(function (data, operation, what, url, response) {
      
        switch (response.status) {
            case 200:
                return data;
            default:
                return data;
        }

    });

    DTDefaultOptions.setLanguage({
        sUrl: '//cdn.datatables.net/plug-ins/1.10.12/i18n/Dutch.json'
    });

    PermRoleStore.defineRole('EMPLOYEE', (roleName, AuthService: AuthService) => {
        'ngInject';
        return AuthService.hasRole(roleName.toLowerCase());
    });

    PermRoleStore.defineRole('SUPERUSER', (roleName, AuthService: AuthService) => {
        'ngInject';
        return AuthService.hasRole(roleName.toLowerCase());
    });

    PermRoleStore.defineRole('BACKOFFICE', (roleName, AuthService: AuthService) => {
        'ngInject';
        return AuthService.hasRole(roleName.toLowerCase());
    });

    PermRoleStore.defineRole('TIMESHEETS', (roleName, AuthService: AuthService) => {
        'ngInject';
        return AuthService.hasRole(roleName.toLowerCase());
    });

    PermRoleStore.defineRole('FINANCE', (roleName, AuthService: AuthService) => {
        'ngInject';
        return AuthService.hasRole(roleName.toLowerCase());
    });

    PermRoleStore.defineRole('ADMIN', (roleName, AuthService: AuthService) => {
        'ngInject';
        return AuthService.hasRole(roleName.toLowerCase());
    });

    PermRoleStore.defineRole('CUSTOMER', (roleName, AuthService: AuthService) => {
        'ngInject';
        return AuthService.hasRole(roleName.toLowerCase());
    });

}];



// WEBPACK FOOTER //
// ./src/app/main/app.run.ts